
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pakkereiser/kart",
      function () {
        return require("private-next-pages/pakkereiser/kart.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pakkereiser/kart"])
      });
    }
  